export const BOOTSTRAP_TEMPLATES = 'BOOTSTRAP_TEMPLATES'
export const TEMPLATE_VERSIONS = 'TEMPLATE_VERSIONS'

export const SET_TOTAL_COMMUNICATIONS = 'SET_TOTAL_COMMUNICATIONS'
export const SET_SELECTED_COMMUNICATIONS = 'SET_SELECTED_COMMUNICATIONS'
export const SET_SELECT_ALL_STATE = 'SET_SELECT_ALL_STATE'
export const ADD_COMMUNICATION = 'ADD_COMMUNICATION'
export const UPDATE_COMMUNICATION = 'UPDATE_COMMUNICATION'
